<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BForm, BFormInput, BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, BOverlay, BCard, BFormTextarea, BSpinner,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import SLSItemService from '@/services/SistemaDKP/SLSItem.service';
import SLSItemExService from '@/services/SistemaDKP/SLSitemEx.service';
import SLSitemExValoresService from '@/services/SistemaDKP/SLSitemExValores.service';
import { required, email } from '@validations';
import InputCustom from '@/components/InputCustom.vue';

const slsItemService = new SLSItemService();
const slsItemExService = new SLSItemExService();
const sLSitemExValoresService = new SLSitemExValoresService();
export default {
  components: {
    InputCustom,
    BCard,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormInput,
    BFormTextarea,
    BSpinner,
    BOverlay,
  },
  data() {
    return {
      dataForm: {
        item_id: '',
        item_descricao: '',
        item_peso_bruto: '',
        item_peso_liquido: '',
        item_codigo_origem: '',
        item_codigo_ncm: '',
        item_codigo_ean: '',
        item_codigo_gtin: '',
      },
      isLoading: false,
    };
  },
  computed: {
    fieldsDefaults() {
      const fields = this.$store.getters['ItemStore/GET_FIELDS_DEFAULT'];
      return Array.isArray(fields) ? fields.filter((field) => field && field.key) : [];
    },
  },
  methods: {
    async validateForm() {
      const isValid = await this.$refs.refFormData.validate();
      if (isValid) {
        this.$emit('onSubmit', this.dataForm);
      }
    },
    resetForm() {
      this.$refs.refFormData.reset();
    },
  },
  async mounted() {
    this.isLoading = true;
    try {
      this.$nextTick(() => {
        this.$refs.refFormData.reset();
      });
      const fieldDefaults = await slsItemService.getItemDescribe();
      const fieldsCustom = await slsItemExService.index();
      const safeDefaults = Array.isArray(fieldDefaults) ? fieldDefaults : [];
      const safeCustom = Array.isArray(fieldsCustom) ? fieldsCustom : [];
      this.$store.commit('ItemStore/SET_FIELDS_DEFAULT', safeDefaults.concat(safeCustom));
      if (this.$route.params.id) {
        const valuesCustom = await sLSitemExValoresService.findAllByItem(this.$route.params.id);
        const objetTransform = {};
        (Array.isArray(valuesCustom) ? valuesCustom : []).forEach((itemValue) => {
          Object.keys(itemValue).forEach((key) => {
            const exclued = ['key', 'label'];
            if (!exclued.includes(key) && itemValue[key] !== null) {
              objetTransform[itemValue.key] = itemValue[key];
            }
          });
        });
        console.log('objetTransform', objetTransform);
        await slsItemService.getItemById(this.$route.params.id)
          .then((response) => {
            this.$store.commit('ItemStore/SET_ITEM', response.data);
            this.dataForm = { ...response.data, ...objetTransform };
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<template>
  <b-row>
    <b-col cols="12">
      <b-button variant="primary" @click="$router.go(-1)">
        Voltar
      </b-button>
    </b-col>

    <b-col cols="12" class="mt-2">
      <b-overlay :show="isLoading">
        <b-card no-body class="mb-0">
          <div class="m-2">
            <b-form ref="refFormData">
              <ValidationObserver ref="refFormData" v-slot="{ invalid }">
                <b-row>
                  <b-col cols="12" md="6" v-for="(field, index) in fieldsDefaults" :key="index">
                    <InputCustom :field="field" :value-field="dataForm[field.key]" />
                  </b-col>

                  <b-col v-if="!isLoading && fieldsDefaults.length === 0" cols="12">
                    <b-alert variant="warning" show class="mb-0">
                      Não foi possível carregar os campos do item. Tente novamente.
                    </b-alert>
                  </b-col>
                </b-row>

              </ValidationObserver>
            </b-form>
          </div>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>
